import React from 'react';
import './filters.scss';
import KeywordsFilter from './keywords-filter';
import CategoriesFilter from './categories-filter';
import LocationsFilter from './locations-filter';
import CompaniesFilter from './companies-filter';
import TargetGroupsFilter from './target-groups-filter';
import OrgUnitsFilter from './org-units-filter';
import LanguagesFilter from './languages-filter';
import MapsFilter from './maps-filter';
import FiltersProperties from './types/filtersProperties';

const Filters = ({
  hideLabel = false,
  showColon = false,
  className,
  withMaps = true,
  keywordsFilterFullWidth = false,
}: FiltersProperties) => (
  <div className={`dvinci-job-filters row row-cols-1 ${className}`}>
    {withMaps && <MapsFilter />}
    <KeywordsFilter hideLabel={hideLabel} showColon={showColon} className={keywordsFilterFullWidth ? 'w-100' : ''} />
    <CategoriesFilter hideLabel={hideLabel} showColon={showColon} />
    <LocationsFilter hideLabel={hideLabel} showColon={showColon} />
    <CompaniesFilter hideLabel={hideLabel} showColon={showColon} />
    <TargetGroupsFilter hideLabel={hideLabel} showColon={showColon} />
    <OrgUnitsFilter hideLabel={hideLabel} showColon={showColon} />
    <LanguagesFilter hideLabel={hideLabel} showColon={showColon} />
  </div>
);

export default Filters;
